import api from './api';
import Cookies from 'js-cookie';

/**
 * Service dos Relatórios administrativos.
 */
export const relatoriosService = {
  /**
   * Lista extensões sem pedidos válidos (Concluído + valor > 0) no período.
   * Retorna { success, data:[…], meta:{ dataInicio, dataFim, total } }
   */
  async extensoesSemPedidos({ dataInicio, dataFim, signal } = {}) {
    const response = await api.get('/relatorios/extensoes-sem-pedidos', {
      params: { dataInicio, dataFim },
      signal,
    });
    return response.data;
  },

  /**
   * Baixa o PDF do relatório. Usa fetch direto (em vez do axios) para
   * conseguir manipular o blob com facilidade e abrir/baixar pelo nome
   * sugerido pelo header Content-Disposition.
   */
  async baixarExtensoesSemPedidosPdf({ dataInicio, dataFim }) {
    const token = Cookies.get('auth_token') || localStorage.getItem('auth_token');
    const baseUrl = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
      ? (process.env.REACT_APP_API_URL || 'http://localhost:3001/api')
      : 'https://api.ibe.elshadaysystems.com.br/api';
    const url = `${baseUrl}/relatorios/extensoes-sem-pedidos/pdf?dataInicio=${encodeURIComponent(dataInicio)}&dataFim=${encodeURIComponent(dataFim)}`;

    const resp = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!resp.ok) {
      let msg = `HTTP ${resp.status}`;
      try { const j = await resp.json(); msg = j.message || j.error || msg; } catch {}
      throw new Error(msg);
    }
    const blob = await resp.blob();
    const filename = `extensoes-sem-pedidos_${dataInicio}_a_${dataFim}.pdf`;
    const a = document.createElement('a');
    const blobUrl = URL.createObjectURL(blob);
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  },
};

export default relatoriosService;
